import HocLazyLoad from './hoc-lazy-load'

export default HocLazyLoad
